module.exports = __webpack_public_path__ + "static/media/logo-marta-valle.cf0fb6cc.png";